import { avatarPlaceholderSRC } from '../../utils';

export const getExtraPersonInfo = (data, isShowRole, isShowProperty) => {
  const person = data?.person ?? data;
  const info = [];
  const { roleName, propertyName } = person;
  if (isShowRole && roleName) {
    info.push(roleName);
  }
  if (isShowProperty && propertyName) {
    info.push(propertyName);
  }
  return info.join(' - ');
};
export const getPhotoUrl = (data) => {
  const person = data?.person?.person;
  const thumbnailUrl = person?.photo?.thumbnailUrl;
  return !person?.id ? null : thumbnailUrl || avatarPlaceholderSRC;
};

export const getDoorOpeningsPhotoUrl = (data) => {
  const person = data?.mostDoorOpenings?.person?.person;
  const thumbnailUrl = person?.photo?.thumbnailUrl;
  return !person?.id ? null : thumbnailUrl || avatarPlaceholderSRC;
};

export const getPersonName = (person) =>
  person?.id ? `${person?.firstName} ${person?.lastName}` : null;

export const getDoorOpeningsText = (
  data,
  isShowRole = true,
  isShowProperty = true,
) => {
  const personName = getPersonName(data?.mostDoorOpenings?.person?.person);
  if (!personName) return null;
  let extraPersonInfo;
  if (isShowRole || isShowProperty) {
    extraPersonInfo = getExtraPersonInfo(
      data?.mostDoorOpenings,
      isShowRole,
      isShowProperty,
    );
  }
  return extraPersonInfo ? `${personName}, ${extraPersonInfo}` : personName;
};

export const getMostReceivedText = (
  data,
  isShowRole = true,
  isShowProperty = true,
) => {
  const personName = getPersonName(data?.person?.person);
  if (!personName) return null;
  let extraPersonInfo;
  if (isShowRole || isShowProperty) {
    extraPersonInfo = getExtraPersonInfo(data, isShowRole, isShowProperty);
  }
  return extraPersonInfo ? `${personName}, ${extraPersonInfo}` : personName;
};

export const getPersonUrl = (data) => {
  const person = data?.mostDoorOpenings?.person ?? data?.person;
  if (!person) return null;
  const {
    role: roleId,
    person: { id: personId },
    personRoleId,
    property,
  } = person;
  const pmcId = property?.pmc?.id;
  const buildingId = property?.building?.id;
  return `/redirect?type=person&roleId=${roleId}&personId=${personId}&personRoleId=${personRoleId}&pmcId=${pmcId}&buildingId=${buildingId}`;
};

export const getSRStatisticsUrl = (property) => {
  const { propertyLevel, id } = property;
  return `/redirect?type=sr&${propertyLevel}Id=${id}`;
};

export const getLiveCameraViewUrl = (startDate, endDate) =>
  `/redirect?type=activity&actionType=view_camera&startDate=${startDate}&endDate=${endDate}`;

export const getMessagesSentUrl = (startDate, endDate) =>
  `/redirect?type=activity&actionType=message_send&startDate=${startDate}&endDate=${endDate}`;
